module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Tabs 选项卡")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('tabs', {
    attrs: {
      "list": _vm.list,
      "value": _vm.value
    },
    on: {
      "update:value": function($event) {
        _vm.value = $event
      }
    }
  }, [_c('div', {
    staticClass: "padding15 bg-grayLighter",
    slot: "div1"
  }, [_vm._v("我是div1")]), _vm._v(" "), _c('div', {
    staticClass: "padding15 bg-grayLighter",
    slot: "div2"
  }, [_vm._v("我是div2")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("HTML代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--:value.sync 为必填(以配合双向绑定)-->\n<tabs :list=\"list\" :value.sync=\"value\">\n  <!--slot的值为该容器所对应的name-->\n  <div slot=\"div1\" class=\"padding15 bg-grayLighter\">我是div1</div>\n  <div slot=\"div2\" class=\"padding15 bg-grayLighter\">我是div2</div>\n</tabs>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Script代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("export default {\n  data() {\n    return {\n      list: [\n        { name: 'div1' },\n        { name: 'div2' }\n      ],\n      value: 'div1' // 需要激活的容器name\n    }\n  }\n}\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("list")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("选项卡的name列表")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("激活的Panel(为了配合双向绑定，改为必填项)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16fc2d90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/tabs-demo.vue
// module id = 386
// module chunks = 1